import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Table } from "@tanstack/react-table";
import { readClientsClientsGet } from "@/client-admin";
import { Input } from "@/components/ui/input";
import { SelectClientCodeComboBox } from "@/components/admin/UserClientLinkTable/SelectClientCodeComboBox";
import { SelectClientNameComboBox } from "@/components/admin/UserClientLinkTable/SelectClientNameComboBox";
import { DataTableViewOptions } from "@/components/admin/UserTable/data-table-view-options";
import { LoadingComponent } from "@/components/LoadingComponent";
import { UserClientPermissionDetail } from "@/client-admin/types.gen";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar({ table }: DataTableToolbarProps<UserClientPermissionDetail>) {
  const [selectedClientCode, setSelectedClientCode] = useState<string | null>(null);
  const [selectedClientName, setSelectedClientName] = useState<number | null>(null);
  const { data, isLoading, isError } = useQuery({
    queryKey: ["clients"],
    queryFn: () => readClientsClientsGet(),
  });

  if (isLoading) return <LoadingComponent />;
  if (isError) return <div>Error fetching clients</div>;

  return (
    <div className="grid grid-cols-1 gap-2">
      <div className="flex flex-col gap-2 py-2 sm:flex-row">
        <Input
          placeholder="Filter by email..."
          value={(table.getColumn("email")?.getFilterValue() as string) ?? ""}
          onChange={(event) => table.getColumn("email")?.setFilterValue(event.target.value)}
          className="w-full sm:w-1/5"
        />
        <SelectClientCodeComboBox
          value={selectedClientCode}
          onChange={(selectedOption) => {
            setSelectedClientCode(selectedOption ? selectedOption : null);
            table.getColumn("client_code")?.setFilterValue(selectedOption ? selectedOption : null);
          }}
          placeholder="Filter user by client code..."
          data={data}
        />
        <SelectClientNameComboBox
          value={selectedClientName}
          onChange={(selectedOption) => {
            setSelectedClientName(selectedOption ? selectedOption : null);
            table.getColumn("client_name")?.setFilterValue(selectedOption ? selectedOption : null);
          }}
          data={data}
        />
        <DataTableViewOptions table={table} />
      </div>
    </div>
  );
}
